import { use_slice_user } from '@/hooks/store/use_slices';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';
import { LAYOUT_COLUMN__right } from '../layout_base/LAYOUT_COLUMN__right';

export function HEADER__column_right_default() {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { is_authorized, user_role, user_settings } = use_slice_user(['is_authorized', 'user_role', 'user_settings']);

  /*
   * RENDERS
   */

  /*
   * HTML
   */

  return <LAYOUT_COLUMN__right></LAYOUT_COLUMN__right>;
}
